import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ErrorBoundary } from './components/ErrorBoundary';
import { TenantProvider } from './contexts/TenantContext';
import { PostHogProvider } from './contexts/PostHogProvider';
import App from './App';
import './index.css';import './styles/stage-motion.css';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <TenantProvider>
          <PostHogProvider>
            <App />
          </PostHogProvider>
        </TenantProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>
);